import axios, { AxiosRequestConfig } from "axios";
import { ApiService } from "./ApiService";
import * as AxiosLogger from "axios-logger";
import type { AesGcmEncryptionService } from "../service/encryptionService";
type Encryptor = AesGcmEncryptionService | (() => Promise<AesGcmEncryptionService>);

interface ApiConfig {
  baseURL: string;
  timeout?: number;
  headers?: any;
  responseType?:
    | "json"
    | "arraybuffer"
    | "blob"
    | "document"
    | "text"
    | "stream";
}
export class AxiosBuilder {
  private readonly config: AxiosRequestConfig;
  private encryption?: Encryptor;

  constructor(config?: ApiConfig) {
    this.config = {
      baseURL: config?.baseURL ?? "",
      timeout: config?.timeout ?? 10000,
      headers: config?.headers ?? {},
      responseType: config?.responseType ?? "json",
    };
  }

  baseUrl(url: string): AxiosBuilder {
    this.config.baseURL = url;
    return this;
  }

  timeout(timeout: number): AxiosBuilder {
    this.config.timeout = timeout;
    return this;
  }

  addEncryption(encryption: Encryptor): AxiosBuilder {
    this.encryption = encryption;
    return this;
  }

  responseType(
    responseType:
      | "json"
      | "arraybuffer"
      | "blob"
      | "document"
      | "text"
      | "stream"
  ): AxiosBuilder {
    this.config.responseType = responseType;
    return this;
  }
  headers(headers: any): AxiosBuilder {
    this.config.headers = headers;
    return this;
  }

  build(): ApiService {
    const instance = axios.create(this.config);
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      instance.interceptors.request.use(AxiosLogger.requestLogger);
      instance.interceptors.response.use(AxiosLogger.responseLogger);
    }
    return new ApiService(instance, this.encryption);
  }
}
